import React, { useEffect } from "react";
import Slider from "react-slick";
import './HomePage.css';

function ProductSlider() {
  const products = [
    { img: "/assets/fence.jpg", title: "Aluminium fence" },
    { img: "/WIP-Pivot.jpg", title: "Pivot Doors" },
    { img: "/WIP-Garage1.jpg", title: "Garage Gates" },
    { img: "/WIP-Full House.jpg", title: "Full House" }
  ];

  // PRELOAD IMAGES FOR CACHE
  useEffect(() => {
    products.forEach((product) => {
      const img = new Image();
      img.src = product.img;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // safe: products never changes

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 600, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <div className="slider-container">
      <h2>Our Featured Work</h2>
      <Slider {...settings}>
        {products.map((product, index) => (
          <div key={index} className="slide-item">
            <img src={product.img} alt={product.title} loading="eager" />
            <h3>{product.title}</h3>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default ProductSlider;
